



























import { Component, Prop, Vue, Emit } from "vue-property-decorator";

@Component
export default class DatePickerComponent extends Vue {
  @Prop()
  label!: string;

  @Prop()
  minimumDate!: string;

  @Prop({ default: [] })
  dates!: string[];

  get datesString() {
    return this.dates.join(", ");
  }
}
